import { useEffect, useState } from "react";
import { Cache } from "../classes/Cache";
import { ModelService } from "../services";
import { IModel } from "../common";

type Params = {
  taskId: string;
  taskCache?: {
    timeToLiveInSeconds?: number;
  };
};

const taskCache = new Cache();

export function useFetchTaskDetails(params: Params) {
  const { taskId } = params;
  const taskTimeToLiveInSeconds = params.taskCache?.timeToLiveInSeconds;
  const [taskDetails, setTaskDetails] = useState<IModel>();
  const [isFetchingTaskDetails, setIsFetchingTaskDetails] = useState(false);

  useEffect(() => {
    const fetchAndSetTaskDetails = async () => {
      try {
        setIsFetchingTaskDetails(true);
        const response = await ModelService.getModelDetails({
          modelId: taskId,
        });
        setTaskDetails(response.data);
        taskCache.set(
          taskId,
          JSON.stringify(response.data),
          taskTimeToLiveInSeconds ? taskTimeToLiveInSeconds * 1000 : 0
        );
        setIsFetchingTaskDetails(false);
      } catch (error) {
        console.error("Error fetching task details:", error);
        setIsFetchingTaskDetails(false);
      }
    };

    if (taskCache.get(taskId)) {
      setTaskDetails(JSON.parse(taskCache.get(taskId)));
      return;
    }

    fetchAndSetTaskDetails();
  }, [taskId, taskTimeToLiveInSeconds]);

  return { taskDetails, isFetchingTaskDetails };
}
